import React from "react";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
    const { t } = useTranslation();
    return (
        <footer className="footer py-16 pb-8">
            <div className="contain flex flex-col lg:flex-row items-center gap-16 lg:gap-0 lg:justify-between">
                <div className="name font-bold text-lg text-white flex-[1] justify-start">
                    <span className="year text-[#8a8a8a]">2024</span>{" "}
                    <span>{t("footer.siteName")}</span>
                </div>
                <div className="logo flex-[2] flex justify-center ">
                    <a href="#header">
                        <img src="/logonew.png" className="w-[200px] h-auto" width={419} height={116} alt="Kochan Productions" />
                    </a>
                </div>
                <div className="text-white flex gap-10 flex-[1] justify-end">
                    <a
                        href="https://www.instagram.com/kchnmuco/?hl=tr"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                    >
                        <FaInstagram fontSize={20} aria-hidden="true" />
                    </a>
                    <a
                        href="https://www.linkedin.com/in/m%C3%BCcahit-ko%C3%A7han-606660308/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="LinkedIn"
                    >
                        <FaLinkedinIn fontSize={20} aria-hidden="true" />
                    </a>
                </div>
            </div>
            <div className="policy text-sm text-center text-[#aaa] mt-12">
                {t("footer.createdBy")} <Link className="hover:text-white transition" to={"https://meanval.com/"}>meanval</Link> ©
                {" "}{t("footer.rights")}
            </div>
        </footer>
    );
};

export default Footer;
